export function filterElements(filter, child) {
  return child?.type?.displayName === 'DropdownCategory' || child.props.label?.toLowerCase().includes(filter?.toLowerCase());
}